/**
 * Runtime-configurable app config.
 *
 * These values are never baked into the webpack bundle at build time — they're
 * sourced solely from `window.dahreplyConfig`, rendered fresh per-request by
 * Rails from `ENV` in `app/views/layouts/vueapp.html.erb`. This lets a
 * pre-built image be (re)configured at runtime via the host's .env without
 * ever rebuilding the frontend bundle.
 */
export const appConfig = key =>
  typeof window !== 'undefined' && window.dahreplyConfig
    ? window.dahreplyConfig[key]
    : undefined;

export default appConfig;
